import gql from 'graphql-tag';

export default gql`
  query ManageEnrollSubjectExport($subject: MongoID!, $page: Int, $perPage: Int) {
    manageEnrollSubjectPage(subject: $subject, page: $page, perPage: $perPage, includeDetails: true) {
      items {
        _id
        subjectId
        student {
          _id
          username
          email
          mobile
          firstname
          lastname
          role
          avatar
        }
        certificatestatus
        creditstatus
        payment_image
        answers
        time
        name
        status
      }
      progresses {
        _id
        studentId
        contentId
        progress
        zoomprogress
        certificateProgress
        path
      }
      quizAnswers {
        studentId
        contentId
        answer
      }
      surveyAnswers {
        studentId
        contentId
        surveyAnswers
      }
      total
      page
      perPage
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;
